export const normalizeWhatsAppPhone = (value: string): string => {
  const trimmed = value?.trim() ?? ''
  if (!trimmed) return ''

  const cleaned = trimmed.replace(/^whatsapp:/i, '')
  let digits = cleaned.replace(/\D/g, '')

  if (!digits) return ''

  if (digits.startsWith('00')) {
    digits = digits.slice(2)
  }

  if (digits.startsWith('0') && !digits.startsWith('00')) {
    digits = `60${digits.slice(1)}`
  }

  return digits
}
